import { deleteManagerHour, editManagerHour } from '../../../../logic/requests/employees';

export const handleSubmit = (id, data, onSubmit) => {
    const toSend = {
        ...data,
        price: data.price?.replace(',', '.'),
        id_User: +data.manager,
        type: +data.type,
    };

    if (!Object.keys(toSend).length) return onSubmit?.();

    editManagerHour(id, toSend)
        .then((res) => {
            onSubmit?.(res);
        })
        .catch((err) => {
            console.error('editManagerHour', err);
        });
};

export const handleDelete = (id, onSuccess, confirmPopup, setConfirmPopup) => {
    if (!confirmPopup) setConfirmPopup(true);

    if (confirmPopup) {
        deleteManagerHour(id)
            .then(() => {
                onSuccess?.();
            })
            .catch((err) => {
                console.error('handleDelete', err);
            });
    }
};
